<template>
  <div style="margin-bottom: 25px;">
    <div class="details gray-bg">
      <div class="vos-title">
        Assignment
      </div>
      <div class="field padded-bottom-border">
        <div class="control">
          <div class="columns">
            <div class="column is-6">
              <label>Job</label>
              <div class='formfield'>
                {{ digitalForm.job_no }}
              </div>
            </div>
            <div class="column is-6">
              <label>Language</label>
              <div class='formfield'>
                {{ digitalForm.target_language }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="field padded-bottom-border">
        <div class="control">
          <div class="columns">
            <div class="column is-6">
              <label>Service Date</label>
              <div class='formfield'>
                {{ digitalForm.service_date }}
              </div>
            </div>
            <div class="column is-6">
              <label>Service time</label>
              <div class='formfield'>
                {{ digitalForm.service_time }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="field padded-bottom-border">
        <div class="control">
          <div class="columns">
            <div class="column is-6">
              <label>LEP/Case Name</label>
              <div class='formfield'>
                {{ digitalForm.case_name_lep }}
              </div>
            </div>
            <div class="column is-6">
              <label>Case #/MRN</label>
              <div class='formfield'>
                {{ digitalForm.case_num_mrn }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="digitalForm.job_type_id == 1" class="field padded-bottom-border">
        <div class="control">
          <div class="columns">
            <div class="column is-6">
              <label>Location</label>
              <div class='formfield'>
                {{ digitalForm.location_name }}
              </div>
            </div>
            <div class="column is-6">
              <label>Address / Department</label>
              <div class='formfield'>
                {{ digitalForm.dept_num }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="field padded-bottom-border">
        <div class="control">
          <div class="columns">
            <div class="column is-6">
              <label>Service Description</label>
              <div class='formfield'>
                {{ digitalForm.service_description }}
              </div>
            </div>
            <div class="column is-6">
              <label>Facilitator</label>
              <div class='formfield'>
                {{ digitalForm.contact_name }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="vos-title">
        Must Be Completed By <span v-show="digitalForm.job_type_id == 1">Site Personnel</span><span v-show="digitalForm.job_type_id != 1">You</span>
      </div>
      <div class="field padded-bottom-border">
        <div class="control">
          <div class="columns">
            <div class="column is-6">
              <label><span v-bind:class="{ 'is-danger': arrival_time_error }"><span v-show="digitalForm.job_type_id == 1">Interpreter
                    Arrival</span><span v-show="digitalForm.job_type_id != 1">Logged
                    In</span> Time *</span></label>
              <div class='formfield'>
                <!-- <input class="input" @keyup="enableSave" v-bind:class="{ 'is-danger': arrival_time_error }" type="text"
                  :value="digitalForm.arrival_time" @input="update('arrival_time', $event.target.value)"
                  @focus="checkError('arrival_time_error')" placeholder="Arrival Time" /> -->
                  <vue-timepicker
                    lazy
                    format="hh:mm A"
                    close-on-complete
                    manual-input
                    @change="captureTime($event, 'arrival_time', 'arrival_time_error', 'invalid_arrival_time_error')"
                    :input-class="{
                      'show-time-error': arrival_time_error
                    }"></vue-timepicker>
                    <p v-if="invalid_arrival_time_error" style="color:red;">Invalid time format (ex: 3:30 AM)</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="field padded-bottom-border">
        <div class="control">
          <div class="columns">
            <div class="column is-6">
              <label><span v-bind:class="{ 'is-danger': start_time_error }">Start
                  Time *</span></label>
              <div class='formfield'>
                <!-- <input class="input" @keyup="enableSave" v-bind:class="{ 'is-danger': start_time_error }" type="text"
                  :value="digitalForm.start_time" @input="update('start_time', $event.target.value)"
                  @focus="checkError('start_time_error')" placeholder="Start Time" /> -->
                  <vue-timepicker
                    lazy
                    format="hh:mm A"
                    close-on-complete
                    manual-input
                    @change="captureTime($event, 'start_time', 'start_time_error', 'invalid_start_time_error')"
                    :input-class="{
                      'show-time-error': start_time_error
                    }"></vue-timepicker>
                    <p v-if="invalid_start_time_error" style="color:red;">Invalid time format (ex: 3:30 AM)</p>
              </div>
            </div>
            <div class="column is-6">
              <label><span v-bind:class="{ 'is-danger': end_time_error }">End
                  Time *</span></label>
              <div class='formfield'>
                <!-- <input class="input" @keyup="enableSave" v-bind:class="{ 'is-danger': end_time_error }" type="text"
                  :value="digitalForm.end_time" @input="update('end_time', $event.target.value)"
                  @focus="checkError('end_time_error')" placeholder="End Time" /> -->
                  <vue-timepicker
                    lazy
                    format="hh:mm A"
                    close-on-complete
                    manual-input
                    @change="captureTime($event, 'end_time', 'end_time_error', 'invalid_end_time_error')"
                    :input-class="{
                      'show-time-error': end_time_error
                    }"></vue-timepicker>
                    <p v-if="invalid_end_time_error" style="color:red;">Invalid time format (ex: 3:30 AM)</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="digitalForm.job_type_id == 1" class="field padded-bottom-border">
        <div class="control">
          <div class="columns">
            <div class="column is-6">
              <label><span v-bind:class="{ 'is-danger': authorizer_name_error }">Authorizer
                  Name (First & Last) *</span></label>
              <div class='formfield'>
                <input class="input" @keyup="enableSave" v-bind:class="{ 'is-danger': authorizer_name_error }" type="text"
                  :value="digitalForm.authorizer_name" @input="update('authorizer_name', $event.target.value)"
                  @focus="checkError('authorizer_name_error')" placeholder="Authorizer Name" />
              </div>
            </div>
            <div class="column is-6">
              <label><span v-bind:class="{ 'is-danger': authorizer_phone_error }">Authorizing
                  Phone Number *</span></label>
              <div class='formfield'>
                <input class="input" @keyup="enableSave" v-bind:class="{ 'is-danger': authorizer_phone_error }"
                  type="text" :value="digitalForm.authorizer_phone"
                  @input="update('authorizer_phone', $event.target.value)" @focus="checkError('authorizer_phone_error')"
                  placeholder="Authorizing Phone Number" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="field padded-bottom-border">
        <div class="control">
          <div class="columns">
            <div class="column is-12">
              <label><span v-bind:class="{ 'is-danger': authorizer_signature_error }"><span
                    v-if="digitalForm.job_type_id == 1">Authorizing Signature Must Be
                    Site Personnel *</span><span v-else-if="digitalForm.job_type_id != 1">Your Signature
                    *</span></span></label>
              <div class='formfield'>
                <Signature @change-signature="changeSignature" @clear="clear"></Signature>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="vos-title">
        Interpreter Notes
      </div>
      <div class="field padded-bottom-border">
        <div class="control">
          <div class="columns">
            <div class="column is-12">
              <label>Interpreter Name</label>
              <div class='formfield'>
                {{ digitalForm.vendor_full_name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="digitalForm.job_type_id == 1 && digitalForm.client_id == 916">
        <div class="field padded-bottom-border">
          <div class="control">
            <div class="columns">
              <div class="column is-12">
              <label>
                <input type="checkbox"
                  :checked="digitalForm.patient_no_show" 
                  :disabled="digitalForm.patient_late"
                  @click="enableSave"
                  @change="update('patient_no_show', $event.target.checked)" />
                Patient Was No Show
              </label>
              </div>
            </div>
          </div>
        </div>
        <div class="field padded-bottom-border">
          <div class="control">
            <div class="columns">
              <div class="column is-12">
              <label>
                <input type="checkbox"
                  :checked="digitalForm.patient_late" 
                  :disabled="digitalForm.patient_no_show"
                  @click="enableSave"
                  @change="update('patient_late', $event.target.checked)" />
                Patient Was Late
              </label>
              </div>
            </div>
          </div>
        </div>
        <div class="field padded-bottom-border" v-if="digitalForm.patient_late">
          <div class="control">
            <div class="columns">
              <div class="column is-6" v-if="digitalForm.patient_late">
                <label>How Late?</label>
                <div class='formfield'>
                  <input type="text" class="input" :value="digitalForm.patient_late_time"
                    @change="update('patient_late_time', $event.target.value)" @keyup="enableSave"
                    placeholder="Ex: 30 minutes" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="field">
          <div class="control">
            <div class="columns">
              <div class="column is-12">
              <label>
                <input type="checkbox" :checked="digitalForm.patient_helped" @click="enableSave"
                  @change="update('patient_helped', $event.target.checked)" />
                Helped patient schedule next appointment.
              </label>
              </div>
            </div>
          </div>
        </div>
        <div v-if="digitalForm.patient_helped">
          <div class="field">
            <div class="control">
              <div class="columns">
                <div class="column is-12" style="padding-top: 0 !important;">
                <label>If so, when is the next appointment?
                </label>
                </div>
              </div>
            </div>
          </div>
          <div class="field padded-bottom-border">
            <div class="control">
              <div class="columns">
                <div class="column is-12" style="padding-top: 0 !important;">
                  <span class="disclaimer">* Please note contract interpreters cannot cancel patient appointments without patient consent.</span>
                </div>
              </div>
            </div>
          </div>
          <div class="field padded-bottom-border">
            <div class="control">
              <div class="columns">
                <div class="column is-6">
                  <label>Appt. Date</label>
                  <div class='formfield'>
                    <input type="text" class="input" :value="digitalForm.next_appt_date"
                      @change="update('next_appt_date', $event.target.value)" @keyup="enableSave" placeholder="Date" />
                  </div>
                </div>
                <div class="column is-6">
                  <label>Appt. Time</label>
                  <div class='formfield'>
                    <input type="text" class="input" :value="digitalForm.next_appt_time"
                      @change="update('next_appt_time', $event.target.value)" @keyup="enableSave" placeholder="Time" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="field padded-bottom-border">
            <div class="control">
              <div class="columns">
                <div class="column is-12">
                  <label>Location</label>
                  <div class='formfield'>
                    <input type="text" class="input" :value="digitalForm.next_appt_location"
                      @change="update('next_appt_location', $event.target.value)" @keyup="enableSave"
                      placeholder="Location" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="field padded-bottom-border">
            <div class="control">
              <div class="columns">
                <div class="column is-12">
                  <label>Service Description</label>
                  <div class='formfield'>
                    <input type="text" class="input" :value="digitalForm.next_appt_service_description"
                      @change="update('next_appt_service_description', $event.target.value)" @keyup="enableSave"
                      placeholder="Please indicate if appointment is follow-up." />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="field padded-bottom-border">
            <div class="control">
              <div class="columns">
                <div class="column is-12">
                <label>
                  <input type="checkbox" :checked="digitalForm.next_appt_available" @click="enableSave"
                    @change="update('next_appt_available', $event.target.checked)" />
                  I am availabile for this appointment.
                </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="field padded-bottom">
        <div class="control">
          <div class="columns">
            <div class="column is-12">
              <label>Notes</label>
              <div class='formfield'>
                <textarea class="textarea" @keyup="enableSave" :value="digitalForm.vos_notes"
                  @input="update('vos_notes', $event.target.value)"
                  placeholder="Do not note mileage in this section. Note changes to appointments, changes to patient info, patient added, appointment time is wrong, location changes, or if interpreter was sent to another office."></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="control" v-if="emailCopy">
          <div class="columns">
            <div class="column">
              <label>Interpreter Email</label> <span class="disclaimer" :class="{ 'is-danger': invalidEmail}" v-if="invalidEmail">* Invalid email address</span>
              <div class='formfield'>
                <input
                  class="input"
                  :class="{ 'is-danger': invalidEmail}"
                  type="text" 
                  :value="digitalForm.email"
                  @focus="resetEmailValidation"
                  @input="validateEmail($event.target.value)" 
                  placeholder="Email" />
              </div>
              <div class="signature-support">
                <span class="disclaimer">Please enter a valid email adddress and we'll send you a confirmation copy of this VOS.</span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>

import { mapState } from "vuex";
import Signature from "@/reusable_components/Signature";

export default {
  name: 'VosFieldsComponent',
  components: {
      Signature
  },
  props: {
    digitalForm: {
      type: Object,
      required: true,
    },
    emailCopy: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      invalidEmail: false,
    }
  },
  computed: {
    ...mapState("requestVos", {
        arrival_time_error: state => state.arrival_time_error,
        start_time_error: state => state.start_time_error,
        end_time_error: state => state.end_time_error,
        invalid_arrival_time_error: state => state.invalid_arrival_time_error,
        invalid_start_time_error: state => state.invalid_start_time_error,
        invalid_end_time_error: state => state.invalid_end_time_error,
        authorizer_name_error: state => state.authorizer_name_error,
        authorizer_phone_error: state => state.authorizer_phone_error,
        authorizer_signature_error: state => state.authorizer_signature_error,
    })
  },
  methods: {
    captureTime(data, field, err1, err2){
      this.update(field, data.displayTime);
      this.checkError(err1)
      this.checkError(err2)
      this.enableSave();
    },
    update(key, value) {
      if(key == 'patient_late' && value == false){
        this.resetPatientLate();
      }
      if(key == 'patient_helped' && value == false){
        this.resetNextAppt();
      }
      this.$emit('update', key, value);
    },
    setVariable(key, value){
      this.$emit('setVariable', key, value);
    },
    changeSignature(data) {
      this.update("authorizer_signature", data);
      this.setVariable("authorizer_signature_error", false);
    },
    clear() {
      this.update("authorizer_signature", "");
    },
    enableSave() {
      this.setVariable("canSave", true);
    },
    checkError(key) {
      this.setVariable(key, false);
    },
    validateEmail(value){
      this.update("email", value);
      // email validation regex pattern
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      // check if email is valid
      if (value.length < 1 || emailRegex.test(value)) {
        this.invalidEmail = false;
      } else {
        this.invalidEmail = true;
      }
    },
    resetEmailValidation(){
      this.invalidEmail = false;
    },
    // reset if checkbox is unchecked
    resetPatientLate(){
      this.update("patient_late_time", "");
    },
    // reset if checkbox is unchecked
    resetNextAppt(){
      this.update("next_appt_date", "");
      this.update("next_appt_time", "");
      this.update("next_appt_location", "");
      this.update("next_appt_service_description", "");
      this.update("next_appt_available", "");
    }
  
  }
}
</script>
<style scoped>
span.is-danger {
  color: red;
}

.vos-title {
    font-weight: bold;
    font-size: 14px;
    margin-top: 5px;
}

.padded-bottom-border {
  padding-bottom: 10px !important;
}

.gray-bg label,
.cancelled-bg label {
  margin-top: 5px !important;
}

input[type="checkbox"] {
  margin-right: 10px;
  transform: scale(1.3);
}

.disclaimer{
  font-size: 12px;
}

/* smartphones, iPhone, portrait 480x320 phones */
@media only screen and (max-width: 1280px) {
	#app {
		padding: 0 !important;
	}

	.columns:not(.is-desktop) {
		display: block !important;
	}

	.vs-form {
		margin: 0 !important;
	}

	.subtitle {
		font-weight: bold;
		margin-bottom: 5px !important;
		font-size: 2em !important;
		color: #4a4a4a !important;
	}

	.vos-title {
		font-size: 2em;
		font-weight: bold;
		margin-top: 5px;
	}

	.vos-content {
		margin-top: 20px;
	}

	.vs-form {
		min-width: 400px !important;
		background: #fff !important;
		height: calc(100% - 10px);
	}

	label {
		font-size: 1em !important;
		font-weight: 600 !important;
		color: #666b82 !important;
	}

	input[type="text"],
	input[type="search"],
	input[type="password"] {
		font-size: 1em !important;
		border: 1px solid #cfd4d8 !important;
	}

  input[type="checkbox"] {
    transform: scale(3.5);
    margin-right: 25px;
    margin-left: 15px;
  }

	.sub-nav,
	.control {
		font-size: 2em !important;
	}

	.formfield {
		font-size: 1em !important;
	}

	.save-vos {
		font-size: 2em !important;
		width: 100% !important;
		height: 80px !important;
		border-radius: 10px !important;
	}

	.signature-support {
		font-size: 26px !important;
	}

	.center-button {
		display: block !important;
	}

	.textarea:not([rows]) {
		max-height: 600px;
		min-height: 250px !important;
		font-size: 1em !important;
	}

	.column.is-6,
	.column.is-6-tablet {
		flex: none;
		width: 100%;
	}

	.jSignature {
		height: 300px !important;
	}

	.au-title {
		font-size: 1.5em;
		font-weight: bold;
	}

	.au-message {
		font-size: 1.5em;
	}

  .disclaimer{
    font-size: 26px !important;
  }
}

/* hi-res laptops and desktops */
@media (min-width: 1281px) {
	html {
		overflow-y: hidden !important;
	}

	body {
		position: relative !important;
		overflow: auto !important;
		background-color: #fff !important;
	}

	.columns:not(.is-desktop) {
		display: flex !important;
	}

	.vos {
		position: relative;
		margin: 0 auto;
		padding: 10px;
		background-color: #fff;
	}

	.vos-title {
		font-size: 1rem;
		font-weight: bold;
		margin-top: 5px;
	}

	.vs-form {
		width: 900px !important;
		background: #fff !important;
		margin: 0 auto !important;
	}

	.subtitle {
		font-weight: bold;
		font-size: 18px !important;
		margin-bottom: 5px !important;
	}

	label {
		font-size: 14px;
	}

	input[type="text"],
	input[type="search"],
	input[type="password"] {
		font-size: 14px;
	}

	.sub-nav,
	.control {
		font-size: 14px !important;
	}

	.save-vos {
		font-size: 14px !important;
		width: 100px !important;
		height: 50px !important;
		border-radius: 5px !important;
	}

	.jSignature {
		height: 200px !important;
	}
}
</style>